import React, { useState } from 'react';
import {
  Close,
  DeleteButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from './style';
import ReactLoading from 'react-loading';

export const ConfirmDeleteFileModal = ({
  isOpen,
  file,
  setIsOpenConfirmDeletionModal,
  setLoadList,
  loadList,
  moduleUuid,
  deleteFile,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteFile = async () => {
    try {
      setIsLoading(true);
      await deleteFile(file.uuid, 'EquipmentFile');
      setIsOpenConfirmDeletionModal(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalContent>
        <ModalHeader>
          <Close onClick={() => setIsOpenConfirmDeletionModal(false)}>
            &times;
          </Close>
        </ModalHeader>
        <ModalBody>
          <p>Você tem certeza que deseja excluir o arquivo "{file?.name}"?</p>
          <div>
            {file && (
              <DeleteButton
                className="delete"
                type="button"
                onClick={handleDeleteFile}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      display: 'flex',
                    }}
                  >
                    <ReactLoading
                      type="spin"
                      color="#011826"
                      height={24}
                      width={24}
                    />
                  </div>
                ) : (
                  'EXCLUIR'
                )}
              </DeleteButton>
            )}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
